import { useTranslations } from "next-intl";
import React from "react";
import styles from "./suggestList.module.scss";

export const ItemLoading: React.FC = () => {
    const t = useTranslations("component.autoSuggest");

    return (
        <div className={styles.itemInner}>
            <span>
                {t("locateMe.pleaseWait")}
                <span className={styles.dot}>.</span>
                <span className={styles.dot}>.</span>
                <span className={styles.dot}>.</span>
            </span>
        </div>
    );
};
